import { Component } from '@angular/core';
import { ScrollPanelModule } from "primeng/scrollpanel";

@Component({
  selector: 'app-greedy-scroll-panel',
  standalone: true,
  imports: [
    ScrollPanelModule
  ],
  templateUrl: './greedy-scroll-panel.component.html',
  styleUrl: './greedy-scroll-panel.component.scss',
  host: {
    'class': 'block w-full h-full'
  }
})
export class GreedyScrollPanelComponent {

}
